<template lang="pug">
.checkbox-field
  .form-field.form-checkbox
    q-checkbox(dark, :value="value", :label="label", @input="changeValue")
</template>

<script setup>
import { ref, computed, watch } from "vue";

const props = defineProps({
  /* Лейбл чекбокса, строка */
  label: { type: String, default: "", required: true },
  /* Начальное значение поля, булеан или пустое значение, которое отображается на форме как незаполненное поле типа false */
  initialValue: { type: Boolean || null, default: null, required: false },
  /** Проп для вотча на значение select из ключа select в этом пропе и назначения значений текущего поля согласно значению select из ключа values */
  watchSelectValue: { type: Object, default: () => {} },
  /** Текущее значение селекта который мы вотчим из watchSelectValue */
  selectValueForWatch: { type: String || Number || null, default: () => null },
});

const emit = defineEmits(["change", "reset"]);

const value = ref(props.initialValue);

const selectValueForWatch = computed(() => props.selectValueForWatch);

const changeValue = () => {
  emit("change", { value: !value.value });
  value.value = !value.value;
};

const updateValueFromSelectWatch = val => {
  value.value = val;
  emit("change", { value: value.value });
};

const resetValue = () => {
  value.value = null;
  emit("reset");
  changeValue();
};

watch(selectValueForWatch, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    const newFieldValue = props.watchSelectValue?.values?.[newVal] ?? null;
    updateValueFromSelectWatch(newFieldValue);
  }
});
</script>

<script>
export default {
  name: "TextField",
};
</script>

<style scoped lang="scss">
.text-field {
  ::v-deep .text-field-area {
    padding-right: 20px;
  }
}
</style>
